import {
  Box,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Popover,
  Stack,
  Typography,
} from '@mui/material';
import { FC, useRef, useState } from 'react';
import { MENU_ITEMS } from '../../const/menuItems';
import { Colors } from '../../styles/theme';
import Logo from '../Logo';
import SmoothLink from '../SmoothLink';

const HeaderComponent: FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const navBarRef = useRef<HTMLDivElement>(null); // 네비바 ref 추가
  const open = Boolean(anchorEl);

  const handleMenuClick = () => {
    if (navBarRef.current) setAnchorEl(navBarRef.current); // 네비바 전체를 anchor로
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 10,
        backgroundColor: 'white',
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          height: {
            xs: '64px',
            sm: '92px',
          },
          backgroundColor: 'white',
          margin: '0 auto',
          maxWidth: '1440px',
          padding: { xs: '0 16px', sm: '0 40px' },
          width: '100%',
        }}
        ref={navBarRef}
      >
        <Stack direction="row" alignItems="center" spacing={4}>
          <Logo />

          <Stack
            direction="row"
            spacing={4}
            sx={{ display: { xs: 'none', md: 'flex' } }}
          >
            {MENU_ITEMS.map((item) => (
              <SmoothLink
                key={item.label}
                to={item.path}
                style={{
                  cursor: 'pointer',
                  color: '#333',
                  fontFamily: 'Pretendard-Regular',
                  fontWeight: 400,
                  fontSize: '16px',
                  textDecoration: 'none',
                }}
              >
                <Typography key={item.label} variant="body1">
                  {item.label}
                </Typography>
              </SmoothLink>
            ))}
          </Stack>
        </Stack>

        {/* Right: Button (md+) or Hamburger (xs) */}
        <Stack direction="row" alignItems="center" spacing={2}>
          <Button
            component="a"
            href="/shop/login"
            variant="outlined"
            sx={{
              height: '44px',
              px: 3,
              borderRadius: '8px',
              borderColor: '#E2E8F0',
              color: '#0F172A',
              textTransform: 'none',
              fontWeight: 600,
              fontFamily: 'Pretendard-Regular',
              fontSize: '15px',
              display: { xs: 'none', md: 'inline-flex' },
              '&:hover': {
                borderColor: Colors.blue,
                color: Colors.blue,
                background: 'transparent',
              },
            }}
          >
            Login
          </Button>

          <SmoothLink to="/#download" style={{ textDecoration: 'none' }}>
            <Button
              variant="contained"
              sx={{
                height: '54px',
                width: '142px',
                gap: '10px',
                borderRadius: '8px',
                backgroundColor: Colors.blue,
                textTransform: 'none',
                fontWeight: 600,
                fontFamily: 'Pretendard-Regular',
                fontSize: '16px',
                display: { xs: 'none', md: 'inline-flex' },
              }}
            >
              Try It Now
            </Button>
          </SmoothLink>

          <IconButton
            onClick={handleMenuClick}
            sx={{ display: { xs: 'inline-flex', md: 'none' } }}
          >
            <img
              src={open ? '/images/close.svg' : '/images/hamburger.svg'}
              alt={open ? 'Close menu' : 'Open menu'}
              width={24}
              height={24}
            />
          </IconButton>

          <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            elevation={0}
          >
            <List>
              {MENU_ITEMS.map((item) => (
                <SmoothLink
                  to={item.path}
                  style={{ textDecoration: 'none', color: 'inherit' }}
                  key={item.label}
                  onClick={handleClose}
                >
                  <ListItem>
                    <ListItemText primary={item.label} />
                  </ListItem>
                </SmoothLink>
              ))}
            </List>
          </Popover>
        </Stack>
      </Stack>
    </Box>
  );
};

export default HeaderComponent;
